import React from 'react';
import { CheckCircle2, Bot, Clock, Globe2 } from 'lucide-react';
export function Solution() {
  return <section className="py-24 relative overflow-hidden" data-id="element-131">
      <div className="absolute top-1/2 left-0 w-72 h-72 bg-purple-600/10 blur-[100px] rounded-full pointer-events-none" data-id="element-132"></div>

      <div className="container mx-auto px-4" data-id="element-133">
        <div className="flex flex-col lg:flex-row items-center gap-16 max-w-6xl mx-auto" data-id="element-134">
          {/* Image/Mockup Side */}
          <div className="w-full lg:w-1/2 relative" data-id="element-135">
            <div className="relative z-10 rounded-2xl overflow-hidden border border-slate-800 shadow-2xl shadow-purple-500/10" data-id="element-136">
              <img src="https://images.unsplash.com/photo-1664575602276-acd073f104c1?q=80&w=2070&auto=format&fit=crop" alt="Workspace with AI and digital dollars" className="w-full h-auto object-cover opacity-90 hover:opacity-100 transition-opacity duration-500" data-id="element-137" />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-transparent to-transparent" data-id="element-138"></div>
              <div className="absolute bottom-6 left-6 right-6" data-id="element-139">
                <div className="bg-slate-900/80 backdrop-blur-md border border-slate-700 p-4 rounded-xl flex items-center gap-4" data-id="element-140">
                  <div className="w-12 h-12 bg-green-500/20 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-141">
                    <Bot className="w-6 h-6 text-green-400" data-id="element-142" />
                  </div>
                  <div data-id="element-143">
                    <p className="text-white font-bold" data-id="element-144">DÓLARES CON IA</p>
                    <p className="text-sm text-slate-300" data-id="element-145">
                      El Blueprint Definitivo
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* Decorative elements */}
            <div className="absolute -top-6 -right-6 w-24 h-24 bg-blue-500/20 rounded-full blur-2xl" data-id="element-146"></div>
            <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-purple-500/20 rounded-full blur-2xl" data-id="element-147"></div>
          </div>

          {/* Content Side */}
          <div className="w-full lg:w-1/2" data-id="element-148">
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-6 leading-tight" data-id="element-149">
              Tu Escalera a la{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-blue-400" data-id="element-150">
                Libertad Financiera
              </span>
            </h2>

            <p className="text-lg text-slate-300 mb-8 leading-relaxed" data-id="element-151">
              Presentamos <strong data-id="element-152">DÓLARES CON IA</strong>. El sistema comprobado
              que te enseña a usar la Inteligencia Artificial como tu equipo de
              trabajo personal. La IA es la herramienta que te permite hacer el
              trabajo de 5 horas en solo 20 minutos.
            </p>

            <div className="space-y-6" data-id="element-153">
              <div className="flex items-start gap-4" data-id="element-154">
                <div className="mt-1 bg-purple-500/20 p-2 rounded-lg" data-id="element-155">
                  <Clock className="w-6 h-6 text-purple-400" data-id="element-156" />
                </div>
                <div data-id="element-157">
                  <h4 className="text-xl font-bold text-white mb-1" data-id="element-158">
                    Multiplicá tu Tiempo
                  </h4>
                  <p className="text-slate-400" data-id="element-159">
                    Automatizá tareas tediosas y entregá resultados premium en
                    tiempo récord usando ChatGPT, Midjourney y más.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-160">
                <div className="mt-1 bg-blue-500/20 p-2 rounded-lg" data-id="element-161">
                  <Globe2 className="w-6 h-6 text-blue-400" data-id="element-162" />
                </div>
                <div data-id="element-163">
                  <h4 className="text-xl font-bold text-white mb-1" data-id="element-164">
                    Clientes Globales
                  </h4>
                  <p className="text-slate-400" data-id="element-165">
                    Aprendé a prospectar y cerrar clientes en EE.UU. y Europa
                    que pagan en dólares sin pestañear.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-166">
                <div className="mt-1 bg-green-500/20 p-2 rounded-lg" data-id="element-167">
                  <CheckCircle2 className="w-6 h-6 text-green-400" data-id="element-168" />
                </div>
                <div data-id="element-169">
                  <h4 className="text-xl font-bold text-white mb-1" data-id="element-170">
                    Cero Experiencia Previa
                  </h4>
                  <p className="text-slate-400" data-id="element-171">
                    No necesitás ser programador ni tener un inglés nativo. Te
                    damos los prompts y las plantillas exactas.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}